import { ManagerMeetingsTable } from './ManagerMeetingsTable'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import { EmployeeDisplayTinyInfo } from '../../types'
import useEmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager from '../../graphql/employee/hooks/useEmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager'
import { MeetingViewInfoBox } from './infoBox/MeetingViewInfoBox'
import useManagerMeetings from '../../graphql/meeting/hooks/useManagerMeetings'
import { useAuth } from '../../context/auth-context'

export const ManagerMeetingsContainer = (): JSX.Element => {
  const { user } = useAuth()

  const { data, error, loading } = useEmployeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager()
  const { data: mangagerMeetingsData, error: managerMeetingsError, loading: managerMeetingsLoading } = useManagerMeetings(user.employeeId)

  if (
    loading ||
    managerMeetingsLoading ||
    error ||
    managerMeetingsError ||
    !data ||
    !mangagerMeetingsData ||
    !data.employeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager ||
    !mangagerMeetingsData.meetingsByManager
  ) {
    return (
      <LoadingAndErrors
        isLoading={loading || managerMeetingsLoading}
        hasNoData={!data || !mangagerMeetingsData}
        error={error || managerMeetingsError}
      />
    )
  }

  const mappedSubordinates = data.employeeDisplayShortInfoByReviewerOrBusinessUnitManagerOrCompanyManager
    .employees as EmployeeDisplayTinyInfo[]

  return (
    <>
      <MeetingViewInfoBox data={mangagerMeetingsData.meetingsByManager} isManagerMeetings={{ employeeList: mappedSubordinates }} />
      <ManagerMeetingsTable employeeList={mappedSubordinates} />
    </>
  )
}
